import { RAID_METADATA_BY_SLUG } from './enums';
import { Expansions, Patches } from '../../../shared/common/enums';
import { ExpansionPatch } from '../../../shared/gameConfig/expansion';

export function getPatchIdForRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid?.patch || Patches.Unknown;
}

export function getExpansionIdForRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid?.expansion || Expansions.Current;
}

export function isCurrentExpansionRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid && raid.expansion === Expansions.Current;
}

export function isNextExpansionRaid(slug: string) {
  const raid = RAID_METADATA_BY_SLUG[slug];
  return raid && raid.expansion === Expansions.Next;
}

export function expansionPatchToString(patch: ExpansionPatch): string {
  // should we throw an exception here?
  if (patch === ExpansionPatch.Unknown || patch <= 0) {
    return 'unknown';
  }

  const value = Number(patch);

  const patchVersion = value % 10;
  const minorVersion = Math.floor((value % 100) / 10);
  const majorVersion = Math.floor(value / 100);

  return `${majorVersion}.${minorVersion}.${patchVersion}`;
}
